export const koKR_tagsViewDropMenu = {
  'tagsView.operation.closeCurrent': '현재 탭 닫기',
  'tagsView.operation.closeOther': '다른 탭 닫기',
  'tagsView.operation.closeAll': '모든 탭 닫기',
  'tagsView.operation.dashboard': '대시보드',
};
